export default __webpack_public_path__ + "static/media/whatsapp-logo.876a6a32.svg";